import { h, Component } from 'preact';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import Tile from 'components/bolt/hub/components/carousel/tile';
import CarouselArrow from 'components/bolt/icons/carouselArrow';
import Store from 'store/store';
import s from 'components/bolt/hub/components/carousel/carousel.sss';
import { onMarkdownClick } from 'utils/bolt';
import HTML from 'components/core/html/html.js';

export default class Carousel extends Component {
	constructor(props) {
		super(props);
		this.onDragStart = this.onDragStart.bind(this);
		this.onDragMove = this.onDragMove.bind(this);
		this.onDragEnd = this.onDragEnd.bind(this);
		this.onSideScroll = this.onSideScroll.bind(this);
		this.state = {
			scrollStart: true,
			scrollEnd: false,
			dragging: false,
			dragDistance: 0,
			currentTileIndex: 0
		};
	}

	componentDidMount() {
		window.addEventListener('mouseup', this.onDragEnd);
	}

	componentWillUnmount() {
		window.removeEventListener('mouseup', this.onDragEnd);
	}

	onDragStart(e) {
		e.preventDefault();
		this.setState({ dragging: true });
		this.mousePosX = e.clientX;
	}


	onDragMove(e) {
		if (!this.state.dragging) return;
		this.setState({ dragDistance: this.state.dragDistance + 1 });
		e.preventDefault();
		this.$sideScroller.scrollLeft = this.$sideScroller.scrollLeft + (this.mousePosX - e.clientX);
		this.mousePosX = e.clientX;
	}

	onDragEnd() {
		setTimeout(() => {
			this.setState({ dragging: false, dragDistance: 0 });
		}, 50);
	}

	componentDidUpdate(prevProps) {
		if (this.props.clientDimensions.width !== prevProps.clientDimensions.width) {
			this.updateScrollPosition();
		}
	}

	updateScrollPosition() {
		if (this.$sideScroller.scrollLeft <= 0) {
			this.setState({
				scrollStart: true
			});
		} else if (Math.ceil(this.$sideScroller.scrollLeft) >= (this.carousel.clientWidth - this.props.clientDimensions.width)) {
			this.setState({
				scrollEnd: true
			});
			Store.emit('HUB_CAROUSEL_ENGAGEMENT', { carouselTitle: this.props.data.anchor });
		} else {
			if (this.state.scrollStart || this.state.scrollEnd) {
				this.setState({
					scrollStart: false,
					scrollEnd: false
				});
			}
		}
	}

	updateCurrentTileIndex() {
		const { data } = this.props;
		const firstTile = document.getElementById(`${data.anchor}-0`);
		const { left, width } = firstTile.getBoundingClientRect();
		const index = Math.abs(Math.round(left / width));
		this.setState({
			currentTileIndex: index
		});
	}

	onSideScroll() {
		this.updateScrollPosition();
		this.updateCurrentTileIndex();
	}

	handleArrowClick(direction, numTiles, paddingOffset, e) {
		if (e) {
			e.preventDefault();
		}
		const { scrollStart, scrollEnd, currentTileIndex } = this.state;
		const { data, clientDimensions } = this.props;

		if (direction === 'prev' && scrollStart) return;
		if (direction === 'next' && scrollEnd) return;

		if (direction === 'prev') {
			if (currentTileIndex === 0) {
				smoothScrollTo(this.$sideScroller, 0, 300, { direction: 'hor' });
			} else {
				let prevTile = document.getElementById(`${data.anchor}-${currentTileIndex - 1}`);
				const isWideDesktop = Store.get().client?.dimensions?.width > 1280;
				const tileOnTheLeft = Math.floor((this.$sideScroller.scrollLeft - (isWideDesktop ? 70 : 30)) / (prevTile.getBoundingClientRect().width + (isWideDesktop ? 40 : 20)));
				if (currentTileIndex >= tileOnTheLeft) {
					prevTile = document.getElementById(`${data.anchor}-${tileOnTheLeft}`);
				}

				smoothScrollTo(this.$sideScroller, prevTile, 300, { direction: 'hor', offset: paddingOffset });
			}
		}

		if (direction === 'next') {
			if (currentTileIndex >= numTiles - 1) {
				const maxScroll = this.carousel.clientWidth - clientDimensions.width;
				smoothScrollTo(this.$sideScroller, maxScroll, 300, { direction: 'hor' });
			} else {
				const nextTile = document.getElementById(`${data.anchor}-${currentTileIndex + 1}`);
				smoothScrollTo(this.$sideScroller, nextTile, 300, { direction: 'hor', offset: paddingOffset });
			}
		}
	}



	render({ data, index, clientDimensions, useTileSlantyTag, fallbackFormat }) {
		if (!data) return;
		const isOddIndex = index % 2 === 1;
		const tag = data.tag;
		const tiles = sortObjectByOrder(data.tiles);
		const { scrollStart, scrollEnd } = this.state;
		const carouselStyle = this.carousel && window.getComputedStyle(this.carousel);
		const carouselPaddingRight = carouselStyle && carouselStyle.getPropertyValue('padding-right').replace(/px/, '');
		const needsScroll = this.carousel && (clientDimensions.width < (this.carousel.clientWidth - carouselPaddingRight));
		const anchor = data.anchor || 'top';
		const carouselId = data.anchor || data.heading || 'top';

		const hasTextOverlayOpen = Store.get()?.hub?.carouselWithTextOverlayOpen === carouselId;


		return (
			<div class={joinClasses(s.container, isOddIndex && s.containerOddBgColor, hasTextOverlayOpen && s.hasTextOverlayOpen)} data-hash-wrapper={anchor} id={carouselId}>
				<div class={joinClasses(s.header)}>
					<h3 class="h3">{data.heading}</h3>
					{needsScroll && (
						<div class={s.arrows}>
							<CarouselArrow
								class={joinClasses(s.left, scrollStart && s.inactive)}
								onClick={() => this.handleArrowClick('prev', tiles.length, carouselPaddingRight)}
								onTouchEnd={(e) => this.handleArrowClick('prev', tiles.length, carouselPaddingRight, e)}
							/>
							<CarouselArrow
								class={joinClasses(s.right, scrollEnd && s.inactive)}
								onClick={() => this.handleArrowClick('next', tiles.length, carouselPaddingRight)}
								onTouchEnd={(e) => this.handleArrowClick('next', tiles.length, carouselPaddingRight, e)}
							/>
						</div>
					)}
					{tag && <div class={joinClasses(s.tags, 'mediumB')}> {tag.toUpperCase()}</div>}
				</div>
				{data.subheading && <HTML tag="h4" markdown content={data.subheading} class={joinClasses('subheading')} onClickCapture={onMarkdownClick} />}
				<div
					class={s.sideScroller}
					ref={ref => this.$sideScroller = ref}
					onMouseDown={this.onDragStart}
					onMouseMove={this.onDragMove}
					onScroll={this.onSideScroll}
				>
					<div
						class={s.carousel}
						ref={ref => this.carousel = ref}
					>
						{!!tiles.length && tiles.map((tile, i) => (
							<Tile
								key={i}
								carouselTitle={anchor}
								id={`${anchor}-${i}`}
								data={tile}
								carouselHeader={data.heading}
								useTileSlantyTag={useTileSlantyTag}
								fallbackFormat={fallbackFormat}
								carouselId={carouselId}
								isHubCarousel={this.props.isHubCarousel}
								dragging={this.state.dragDistance > 10}
								verticalLayout={data.verticalLayout || false}
							/>
						)
						)}
					</div>
				</div>
			</div>
		);
	}
}
